import { Switch } from '@mui/material';
import React, { useEffect } from 'react'
import { Controller, useFormContext } from 'react-hook-form';

const SwitchRow = ({ label, name, lockName, isLocked, toggleLock, handleChangeRadios }) => {
    const { formState: { errors }, watch } = useFormContext();

    return (
        <div className={`row-primary ${isLocked ? "lock_row" : ""}`}>
            <h2 className="col-6">{label}</h2>
            <Controller
                name={name}
                render={({ field }) => (
                    <div className="switch_row">
                        <Switch
                            className={isLocked ? "lockSwitch" : ""}
                            checked={field.value === true}
                            onChange={() => handleChangeRadios(!field.value, field.onChange)}
                            color="primary"
                            disabled={isLocked}
                        />
                    </div>
                )}
            />
            <button
                name={lockName}
                onClick={() => toggleLock(name, lockName)}
                type="button"
                className={`field_locker ${isLocked ? "itslocked" : ""}`}
            >
                <i className={`fa-solid ${isLocked ? "fa-lock" : "fa-unlock"}`}></i>
            </button>
        </div>
    );
};
const FilterSwitch = ({ setLockStates, item, setValue, lockStates, control }) => {


    //#region Filter switch work 
    const fields = [
        { label: "US Based Interpreter", name: "us_based", lockable: true, lockName: "us_based_locked" },
        { label: "Non US Based Interpreter", name: "non_us_based", lockable: true, lockName: "non_us_based_locked" },
        { label: "English To Target Language", name: "english_to_target", lockable: true, lockName: "english_to_target_locked" },
        { label: "Spanish To Target Language", name: "spanish_to_target", lockable: true, lockName: "spanish_to_target_locked" },
        { label: "Court Certified", name: "court_certified", lockable: true, lockName: "court_certified_locked" },
        { label: "Medical Certified", name: "medical_certified", lockable: true, lockName: "medical_certified_locked" },
    ];
    useEffect(() => {
        if (item?.filters) {
            fields.forEach((field) => {
                setValue(field.name, !!item.filters[field.name]);
                setLockStates((prev) => ({ ...prev, [field.name]: !!item.filters[field.lockName] }));
            });
        }
    }, [item]);
    const toggleLock = (name, lockName) => {
        setLockStates((prevState) => {
            const updatedState = { ...prevState, [name]: !prevState[name] };
            setValue(lockName, updatedState[name]);
            return updatedState;
        });
    };
    const handleChangeRadios = (value, onChange) => {
        onChange(value);
    };
    //#endregion
    return (
        <>
            <div className="row-primary row-r justify-content-between flex-row">
                <h2 className='fst-italic'>Filters </h2>
            </div>
            <div className='Filter_wrapper'>
                {fields.map((field) => (
                    <SwitchRow
                        key={field.name}
                        label={field.label}
                        name={field.name}
                        lockName={field.lockName}
                        isLocked={lockStates[field.name]}
                        toggleLock={toggleLock}
                        handleChangeRadios={handleChangeRadios}
                        control={control}
                    />
                ))}
            </div>
        </>
    )
}

export default FilterSwitch